import HeaderClient from '@/components/Layout/Header/Organisms/Header/HeaderClient'
import RecentProducts from '@/components/Layout/Header/Organisms/RecentProducts'
import { getLoginSession } from '@/serverActions/getLoginSession'
import { getProducts } from '@/serverActions/getProducts'

type Props = {
  nextLink?: boolean
  ableToBrowsing?: boolean
  staticComponent?: boolean
}

export default async function Header({ nextLink = true, ableToBrowsing = true, staticComponent = false }: Props) {
  const products = await getProducts({})
  const response = staticComponent ? {} : await getLoginSession(false)
  const loginUser = response.loginSession?.user

  return (
    <HeaderClient nextLink={nextLink} loginUser={loginUser} ableToBrowsing={ableToBrowsing}>
      <RecentProducts products={products} classNames={['l-navigation__leftMenu-contents']} nextLink={false} />
    </HeaderClient>
  )
}
